import { BaseAddress } from './BaseAddress';
export class LocationAddress extends BaseAddress{
    constructor() {
        super();
        this.companyName = null;
        this.position = null;
    }
}
